import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const CreateProcedureTypeViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
CreateProcedureTypeViewTopBar.displayName = "CreateProcedureTypeViewTopBar"
